import React from 'react';
import { Link } from 'react-router-dom';

const Partnerships = () => {
  return (
    <div className="bg-slate-50">
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
        <h1 className="font-serif font-bold text-4xl sm:text-5xl leading-tight tracking-tight text-[#085041]">
          <span className="text-[#0F6E56]">Partnerships</span>
        </h1>

        <div className="mt-8 bg-white border border-slate-200 rounded-xl p-8 sm:p-10 shadow-[6px_6px_0_rgba(15,110,86,0.14)]">
          <p className="text-lg leading-relaxed text-slate-700 max-w-prose">
            At Diagnostic Intelligence, we understand that collaboration is key to success in the
            mission to advance life sciences research globally. We welcome innovation driven
            partnerships to accelerate life sciences research.
          </p>

          <Link
            to="/company/contact"
            className="inline-block mt-8 text-white text-sm font-bold bg-[#187F73] px-5 py-2.5 rounded-xl border border-[#187F73] transition-colors duration-200 hover:bg-[#15695F] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#187F73]/40"
          >
            Contact us
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Partnerships;
